import { render } from "./GS1LinkButton.vue?vue&type=template&id=33d5dd6b&scoped=true"
import script from "./GS1LinkButton.vue?vue&type=script&lang=js"
export * from "./GS1LinkButton.vue?vue&type=script&lang=js"

import "./GS1LinkButton.vue?vue&type=style&index=0&id=33d5dd6b&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d5dd6b"]])

export default __exports__